import { setAttr } from 'redom';
import { computeVerticalPlacement } from 'utilities/element-position';
import { normalizeContainer } from './utilities';

class ElementPlacer {

  constructor(configuration) {

    this.scrollEventRegistrationsCount = 0;

    this.element = configuration.element;
    this.anchor = configuration.anchor;
    this.container = normalizeContainer(configuration.container);
    this.scrollableParent = configuration.scrollableParent;
    this.spacing = configuration.spacing;

  }

  scrollHandler() {

    this.doPlaceVertically();

  }

  registerScrollHandler() {

    if (this.scrollEventRegistrationsCount > 0) {
      // eslint-disable-next-line no-console
      console.error('INEFFICIENT MEMORY MANAGEMENT(aka Memory Leak): Element placement is not cancelled after the last placement.');
    }

    const scrollableParent = this.scrollableParent;
    const scrollHandler = this._scrollHandler = this.scrollHandler.bind(this);

    scrollableParent.addEventListener('scroll', scrollHandler);

    this.scrollEventRegistrationsCount++;

  }

  doPlaceVertically() {

    const element = this.element;
    const anchor = this.anchor;
    const container = this.container;

    const placement = computeVerticalPlacement(element, anchor, container, this.spacing.top);

    setAttr(element, {
      style: {
        top: `${placement.top}px`,
        left: `${placement.left}px`
      }
    });

  }

  async placeVertically() {

    const self = this;

    return new Promise(function resolver(resolve) {

      setTimeout(function someTimeLater() {

        self.doPlaceVertically();
        self.registerScrollHandler();

        resolve();

      }, 10);

    });
  }

  cancel() {

    this.scrollableParent.removeEventListener('scroll', this._scrollHandler);

  }

}

export default ElementPlacer;